import { useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { io } from 'socket.io-client';
import { getUserNotifications, markAsRead, markAllAsRead, deleteNotification as deleteNotificationApi } from '../api/notifications-api';
import { useAuth } from '../../../contexts/AuthContext';
import { getAccessToken } from '../../../lib/tokenStore';

const API_BASE_URL = process.env.REACT_APP_OPPORTUNITY_API_URL ? process.env.REACT_APP_OPPORTUNITY_API_URL.replace('/api/vc/v1/opportunities', '') : 'http://localhost:81';

export const useNotifications = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id) return;

    // Connect to the socket server with the in-memory JWT access token
    const token = getAccessToken();
    const socket = io(API_BASE_URL, {
      auth: { token },
    });

    // Server auto-joins the user's room based on the verified JWT token

    // Listen for new notifications
    socket.on('new_notification', (notification) => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    });

    return () => {
      socket.disconnect();
    };
  }, [user?.id, queryClient]);

  return useQuery({
    queryKey: ['notifications'],
    queryFn: getUserNotifications,
    // Removed refetchInterval: 30000 to disable HTTP polling
  });
};

export const useMarkAsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};

export const useMarkAllAsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markAllAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};

export const useDeleteNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteNotificationApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};
